export const isValidDsku = (subject: string) => subject.match(/^D[A-Z0-9]{10}$/) !== null;
